import React from "react";
import { Baby, BellRing, CalendarCheck, FileText, MapPin, Video } from "lucide-react";
import Tilt from "./template/view.tilt";
import Reveal from "./template/view.reveal";

const FEATURES = [
    { icon: CalendarCheck, color: "#6A52ED", title: "Rendez-vous en ligne", text: "Réservez une consultation au cabinet ou en vidéo, selon les disponibilités réelles du médecin." },
    { icon: Video, color: "#0EA5E9", title: "Téléconsultation", text: "Parlez à votre médecin depuis chez vous, sans trajet ni salle d'attente." },
    { icon: MapPin, color: "#0EA5A4", title: "Pharmacies & labos", text: "Trouvez les pharmacies de garde et les laboratoires les plus proches de vous." },
    { icon: FileText, color: "#F59E0B", title: "Ordonnances numériques", text: "Vos ordonnances et bilans restent dans votre dossier, accessibles à tout moment." },
    { icon: BellRing, color: "#EC4899", title: "Rappels de traitement", text: "Recevez un rappel pour chaque prise de médicament et chaque rendez-vous." },
    { icon: Baby, color: "#8B5CF6", title: "Cycle & grossesse", text: "Suivez votre cycle et l'évolution de votre grossesse, semaine après semaine." },
];

export default function ViewFeature() {
    return (
        <section id="features" className="py-24 bg-[#f7f6fd]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <Reveal className="max-w-2xl">
                    <p className="text-sm font-bold tracking-wider text-brand-600 uppercase">Fonctionnalités</p>
                    <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight text-brand-950">Tout votre parcours de soins, dans une seule app.</h2>
                </Reveal>

                <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {FEATURES.map(({ icon: Icon, color, title, text }, i) => (
                        <Reveal key={title} delay={i * 70}>
                            <Tilt max={7} className="h-full rounded-3xl bg-white p-7 border border-brand-100/60 shadow-[0_1px_2px_rgba(26,18,71,0.04),0_18px_40px_-24px_rgba(26,18,71,0.25)]">
                                <div className="tilt-pop w-12 h-12 rounded-2xl flex items-center justify-center"
                                    style={{ background: `linear-gradient(140deg, ${color}2e, ${color}12)`, color, boxShadow: `0 10px 24px -10px ${color}80` }}>
                                    <Icon className="w-6 h-6" />
                                </div>
                                <h3 className="mt-5 text-lg font-bold text-brand-950">{title}</h3>
                                <p className="mt-2 text-slate-600 leading-relaxed">{text}</p>
                            </Tilt>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
